
































































































































































import { Component, Vue } from "vue-property-decorator";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import TiendaOnlineClientes from "@/store/modules/TiendaOnlineClientes-module";
import { ImagenProducto } from "@/shared/dtos/productosAmazon/ImagenProducto";
import { RouterNames } from "@/router/routernames";
import { medicalUserService } from "@/shared/services/user-service";
import { ssmTokenService } from "@/shared/services/token-service";
import ProcesosProducto from "../procesos/Procesos_producto.vue";
import { ProcessoNums } from "../procesos/ProcessoNums";
import telemetriaClienteModule from "@/store/modules/telemetria_cliente-module";

function getSessionId(): string {
    let sid = sessionStorage.getItem('tele_sid');
    if (!sid) { sid = Math.random().toString(36).substring(2); sessionStorage.setItem('tele_sid', sid); }
    return sid;
}

@Component({
  components: { ProcesosProducto },
})
export default class productoTiendaOnline extends Vue {
  public mainImage = "https://via.placeholder.com/500x500.png?text=Producto";
  public prodcuto: ProductoAmazon = new ProductoAmazon();
  public id_producto = -1;
  public isLoading = true;
  public loadingMessage = "Preparando tu experiencia...";
  private loadingTimer: any = null;
  private _ldScript: HTMLScriptElement | null = null;

  async created() {
    window.scrollTo(0, 0);
    this.isLoading = true;

    const messages = [
      "Preparando tu experiencia...",
      "Calculando tu descuento especial...",
      "Preparando el mejor precio para ti...",
      "Afinando los últimos detalles..."
    ];
    let msgIndex = 0;
    this.loadingTimer = setInterval(() => {
      msgIndex = (msgIndex + 1) % messages.length;
      this.loadingMessage = messages[msgIndex];
    }, 1500);

    const id = Number(this.$route.params.id); // Obtener el ID desde los parámetros de la ruta
    /*
    if (TiendaOnlineClientes.TiendaOnlineClienteses.length === 0) {
      if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
        await TiendaOnlineClientes.getTiendaOnlineClientesesTodos();
      } else {
        await TiendaOnlineClientes.getTiendaOnlineClienteses();
      }
    }

    // Buscar el cliente en la lista TiendaOnlineClientes
    this.prodcuto = TiendaOnlineClientes.TiendaOnlineClienteses.find(
      (prodcuto) => prodcuto.id === id
    )!;
*/
    this.id_producto = id;
    telemetriaClienteModule.postEvento({
      tipo_evento: 'page_view',
      id_producto_wc: id,
      url: window.location.href,
      session_id: getSessionId(),
    });
    if (
      this.$route.query.m &&
      (this.$route.meta.mayorista === undefined ||
        this.$route.meta.mayorista === null ||
        this.$route.meta.mayorista == false)
    ) {
      this.$route.meta.mayorista = this.$route.query.m === "1";
    }

    await TiendaOnlineClientes.getTiendaOnlineClientes(id);

    this.prodcuto = TiendaOnlineClientes.TiendaOnlineClientes;

    this.mainImage = this.prodcuto.hiRes;
    
    // Detener spinner
    if (this.loadingTimer) {
      clearInterval(this.loadingTimer);
    }
    this.isLoading = false;
    this.injectSchema();
  }

  destroyed() {
    if (this.loadingTimer) {
      clearInterval(this.loadingTimer);
    }
    if (this._ldScript && document.head.contains(this._ldScript)) {
      document.head.removeChild(this._ldScript);
    }
  }

  private injectSchema() {
    if (!this.prodcuto || !this.prodcuto.titulo_producto) return;
    const disponible = !this.prodcuto.vendido &&
      this.prodcuto.estado !== 3 && // VendidoEfectivo
      this.prodcuto.estado !== 4;   // VendidoTarjeta
    const schema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": this.prodcuto.titulo_producto,
      "image": [this.mainImage],
      "description": this.prodcuto.descripcion || "",
      "brand": { "@type": "Brand", "name": "Outlet Devoluciones" },
      "offers": {
        "@type": "Offer",
        "url": window.location.href,
        "priceCurrency": "EUR",
        "price": this.prodcuto.precio_venta,
        "priceValidUntil": new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
        "availability": disponible
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
        "seller": { "@type": "Organization", "name": "Outlet Devoluciones" }
      }
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    this._ldScript = script;
  }

  get esta_logeado() {
    return ssmTokenService.hasToken() && medicalUserService.hasuser();
  }

  generateListItems(text: string): string[] {
    // Divide el texto en oraciones usando un delimitador básico como "."
    const sentences = text
      .split(/\. (?=[A-Z])/)
      .map((sentence) => sentence.trim());
    return sentences.map((sentence) => `<li>${sentence}.</li>`);
  }
  changeMainImage(image: ImagenProducto) {
    this.mainImage = image.hiRes;
  }
  get descuento() {
    const descuento =
      ((this.prodcuto.precio_amazon - this.prodcuto.precio_venta) /
        this.prodcuto.precio_amazon) *
      100;
    return `${descuento.toFixed(2)}%`;
  }
  get estado() {
    if (!this.prodcuto) return "En stock. Envío através de Wallapop.";
    if (this.prodcuto.vendido) return "Vendido";
    switch (this.prodcuto.estado) {
      case ProcessoNums.Disponible:
        return "En stock. Envío através de Wallapop.";
      case ProcessoNums.Reservado:
        return "Reservado";
      case ProcessoNums.VendidoEfectivo:
        return "Vendido";
      case ProcessoNums.VendidoTarjeta:
        return "Vendido";
      case ProcessoNums.Devolucion:
        return "Articulo devuleto Devolución";
      case ProcessoNums.MermaRoto:
        return "Articulo Roto";
      case ProcessoNums.Envio:
        return "Articulo en envio";
      case ProcessoNums.PendientePago:
        return "Articulo pendiente de pago";
      case ProcessoNums.Reparacion:
        return "Articulo en reparación";
    }
    return this.prodcuto.estado;
  }
  goto() {
    //this.$router.push({ name: RouterNames.tienda_productos });
    this.$router.back();
  }

  // Añade el producto al carrito (placeholder hasta implementar módulo de carrito)
  annadirAlCarrito() {
    // TODO: conectar con módulo Vuex de carrito cuando esté disponible
    this.$emit('carrito-add', this.prodcuto);
    // Feedback visual temporal
    const snack = document.createElement('div');
    snack.textContent = `¡${this.prodcuto.titulo_producto || 'Producto'} añadido al carrito!`;
    snack.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
      'background:#1a73e8', 'color:#fff', 'padding:14px 28px', 'border-radius:8px',
      'font-weight:600', 'font-size:1rem', 'z-index:9999',
      'box-shadow:0 4px 16px rgba(0,0,0,0.25)', 'transition:opacity 0.4s'
    ].join(';');
    document.body.appendChild(snack);
    setTimeout(() => { snack.style.opacity = '0'; }, 2200);
    setTimeout(() => { if (snack.parentNode) snack.parentNode.removeChild(snack); }, 2700);
  }
}
